import { Component, OnInit, ViewContainerRef } from '@angular/core'
import { NzModalService } from 'ng-zorro-antd/modal'
import { QueryTable } from 'src/app/services/interface/general.model'
import { NzTableQueryParams, NzTableFilterList, NzTableSortOrder } from 'ng-zorro-antd/table'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { Store } from '@ngrx/store'
import { NzNotificationService } from 'ng-zorro-antd/notification'
import { CTAService } from 'src/app/services/cta.service'
import { Employee } from 'src/app/services/interface/employee.model'
import { ViewAgentInquiryComponent } from './view-agent-inquiry/view-agent-inquiry.component'
import { ExportAgentInquiryComponent } from './export-agent-inquiry/export-agent-inquiry.component'

interface ColumnItem {
  name: string
  key: string
  sortOrder: NzTableSortOrder | null
  sortFn: null | boolean
  listOfFilter: NzTableFilterList
  filterFn: null
  left: boolean
  right: boolean
  width: string
}

@Component({
  selector: 'app-agent-inquiry',
  templateUrl: './agent-inquiry.component.html',
})
export class AgentInquiryComponent implements OnInit {
  listOfData: Employee[] = []

  isLoading: boolean = true
  isDownloading: boolean = false
  totalData: number = 0
  pageSize: number = 20
  pageIndex: number = 1

  form: FormGroup
  constructor(
    private modal: NzModalService,
    private viewContainerRef: ViewContainerRef,
    private ctaService: CTAService,
    private fb: FormBuilder,
    private store: Store<any>,
    private notification: NzNotificationService,
  ) {
    this.form = this.fb.group({
      keyword: [null, Validators.compose([Validators.required])],
      prefix: ['full_name', Validators.compose([Validators.required])],
    })
  }

  queryTable: QueryTable = {
    sort: null,
    filters: [],
    pageSize: this.pageSize,
    pageIndex: this.pageIndex - 1,
  }

  listOfColumns: ColumnItem[] = [
    {
      name: 'Actions',
      key: 'actions',
      sortOrder: null,
      sortFn: null,
      listOfFilter: [],
      filterFn: null,
      left: true,
      right: false,
      width: '63px',
    },
    {
      name: 'Inquirer Name',
      key: 'full_name',
      sortOrder: null,
      sortFn: true,
      listOfFilter: [],
      filterFn: null,
      left: false,
      right: false,
      width: '150px',
    },
    {
      name: 'Agent Type',
      key: 'agent_type',
      sortOrder: null,
      sortFn: true,
      listOfFilter: [],
      filterFn: null,
      left: false,
      right: false,
      width: '150px',
    },
    {
      name: 'Email',
      key: 'email',
      sortOrder: null,
      sortFn: true,
      listOfFilter: [],
      filterFn: null,
      left: false,
      right: false,
      width: '150px',
    },
    {
      name: 'Location Type',
      key: 'location_type',
      sortOrder: null,
      sortFn: true,
      listOfFilter: [],
      filterFn: null,
      left: false,
      right: false,
      width: '190px',
    },
    {
      name: 'Building Status',
      key: 'building_status',
      sortOrder: null,
      sortFn: true,
      listOfFilter: [],
      filterFn: null,
      left: false,
      right: false,
      width: '150px',
    },
    {
      name: 'Date of Inquiry',
      key: 'updated_at',
      sortOrder: null,
      sortFn: true,
      listOfFilter: [],
      filterFn: null,
      left: false,
      right: false,
      width: '150px',
    },
  ]

  ngOnInit(): void {
    this.fetchAgentInquiry()
  }

  fetchAgentInquiry() {
    this.isLoading = true
    this.ctaService.getAgentInquiry(this.queryTable).subscribe((r: any) => {
      this.isLoading = false
      this.listOfData = r.rows
      this.totalData = r.count
    })
  }

  onQueryParamsChange(params: NzTableQueryParams): void {
    const { pageSize, pageIndex, sort, filter } = params
    this.queryTable.pageSize = pageSize
    this.queryTable.pageIndex = pageIndex - 1
    const currentSort = sort.find(item => item.value !== null)
    const sortField = (currentSort && currentSort.key) || null
    const sortOrder = (currentSort && currentSort.value) || null

    if (sortField != null && sortOrder != null) {
      this.queryTable.sort = {
        field: sortField,
        order: sortOrder,
      }
    } else {
      this.queryTable.sort = null
    }
    this.fetchAgentInquiry()
  }

  search() {
    if (this.form.value.keyword?.length > 0) {
      this.queryTable.filters = [
        {
          field: this.form.value.prefix,
          keyword: this.form.value.keyword,
        },
      ]
    } else {
      this.queryTable.filters = []
    }
    this.fetchAgentInquiry()
  }

  reset() {
    this.form.reset()
    this.form.patchValue({ prefix: 'full_name' })
    this.queryTable.sort = null
    this.queryTable.filters = []
    this.listOfColumns.forEach(r => {
      r.sortOrder = null
    })
    this.fetchAgentInquiry()
  }

  trackByName(_: number, item: ColumnItem): string {
    return item.name
  }

  destroyModal() {
    this.modal.closeAll()
  }

  async viewAgentInquiry(id: string) {
    const modal = this.modal.create({
      nzTitle: 'View Inquiry',
      nzContent: ViewAgentInquiryComponent,
      nzViewContainerRef: this.viewContainerRef,
      nzComponentParams: {
        id,
      },
      nzMaskClosable: false,
      nzClosable: false,
      nzFooter: [{ label: 'Close', onClick: () => this.destroyModal() }],
      // nzOkText: 'Close',
      // nzOkDisabled: true,
      // nzOnCancel: () => {
      //   console.log('CANCEL')
      // },
      // nzOnOk: () =>
      //   new Promise((resolve, reject) => {
      //     if (instance.submitForm()) {
      //       resolve
      //     } else {
      //       reject
      //     }
      //   }),
      nzWidth: '75%',
    })
    const instance = modal.getContentComponent()
    modal.afterClose.subscribe(() => {
      this.fetchAgentInquiry()
    })
  }

  async exportInquiry() {
    const modal = this.modal.create({
      nzTitle: 'Export Inquiries',
      nzContent: ExportAgentInquiryComponent,
      nzViewContainerRef: this.viewContainerRef,
      nzComponentParams: {},
      nzMaskClosable: false,
      nzClosable: false,
      nzOkText: 'Export',
      // nzOkDisabled: true,
      // nzOnCancel: () => {
      //   console.log('CANCEL')
      // },
      nzOnOk: () =>
        new Promise((resolve, reject) => {
          if (instance.submitForm()) {
            resolve
            this.destroyModal()
          } else {
            reject
          }
        }),
      nzWidth: '30%',
    })
    const instance = modal.getContentComponent()
    modal.afterClose.subscribe(() => {
      this.fetchAgentInquiry()
    })
  }
}
